import React from 'react'; // React import is necessary for JSX syntax, even if not directly used in the code
import PropTypes from 'prop-types';
import classNames from 'classnames';

import s from './SlidingPanel.module.scss';

const SlidingPanel = ({
  children,
  side = 'left',
  isOpen = true,
  onToggle,
  className,
  toggleRef,
  toggleTestId,
}) => {
  const isActive = !isOpen;

  return (
    <div
      className={classNames(s.panel, s[side], {
        [s.closed]: !isOpen,
      }, className)}
    >
      <div className={s.content}>
        {children}
      </div>

      <button
        ref={toggleRef}
        className={s.toggle}
        onClick={onToggle}
        type="button"
        data-testid={toggleTestId}
      >
        <span className="sr-only">Toggle Panel</span>
        <span
          className={classNames(s.arrow, {
            [s.active]: isActive,
          })}
        >
          <span className={classNames(s.stroke, s.top)} />
          <span className={classNames(s.stroke, s.bottom)} />
        </span>
      </button>
    </div>
  );
};

SlidingPanel.propTypes = {
  children: PropTypes.node,
  side: PropTypes.oneOf(['left', 'right']),
  isOpen: PropTypes.bool,
  onToggle: PropTypes.func,
  className: PropTypes.string,
  toggleRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  toggleTestId: PropTypes.string,
};

SlidingPanel.defaultProps = {
  children: null,
  side: 'left',
  isOpen: true,
  onToggle: null,
  className: null,
  toggleRef: null,
  toggleTestId: undefined,
};

export default SlidingPanel;
